/**
 * O contador "N de M" no rótulo dos blocos do painel do cliente em foco
 * (tarefas, contatos, contratos, transcrições) — UMA fórmula para os quatro.
 * Era a mesma conta copiada em cada componente (review do PR #2261, I-07).
 *
 * Dois sabores de "tem mais": quando a lista inteira chega por prop o total é
 * EXATO ("2 de 5"); quando o util que corta a lista só sabe que há algo além
 * do teto, sem quantos (`temMais`), o contador fica ABERTO ("2 de 3+"). Sem
 * sobra, só a contagem — a lista curta não passa por lista completa.
 *
 *   contadorDeLista({ exibidos: 2, total: 5 })      // → '2 de 5'
 *   contadorDeLista({ exibidos: 2, temMais: true }) // → '2 de 3+'
 *   contadorDeLista({ exibidos: 1, total: 1 })      // → '1'
 *
 * A copy mora em `constants/TextChat.js` (`CONTADOR_DE_LISTA`). Sem `?.`/`??`.
 */
import { CONTADOR_DE_LISTA } from '@modules/aawz-intelligence-v2/constants/TextChat'

export function contadorDeLista({ exibidos = 0, total = null, temMais = false } = {}) {
  if (temMais) return CONTADOR_DE_LISTA.aberto(exibidos)
  const conhecido = typeof total === 'number' ? total : exibidos
  if (conhecido > exibidos) return CONTADOR_DE_LISTA.parcial(exibidos, conhecido)
  return CONTADOR_DE_LISTA.total(exibidos)
}
